import React, { useMemo, useContext } from "react";
import { useDepartment } from "../../stores/departmentStore";
import userContext from "../../context/UserContext";
import { useDarkMode } from "../../context/darkModeContext";

export default function BrowseByDepartment({ activeDept, onSelectDept }) {
  const departments = useDepartment((state) => state.departments);
  const users = useContext(userContext).users;
  const { darkMode } = useDarkMode();

  const onboardedUsers = useMemo(() => {
    return (users || []).filter(
      (u) => u.status === "onboarded" && u.flags?.is_approved === true
    );
  }, [users]);

  const departmentStats = useMemo(() => {
    return (departments || []).map((dept) => {
      const members = onboardedUsers.filter((user) => {
        if (Array.isArray(user.dept_ids) && user.dept_ids.includes(dept.id))
          return true;
        if (
          Array.isArray(user.dept_names) &&
          user.dept_names.includes(dept.name)
        )
          return true;
        if (typeof user.dept === "string" && user.dept === dept.name)
          return true;
        return false;
      });
      return { ...dept, memberCount: members.length };
    });
  }, [departments, onboardedUsers]);

  return (
    <>
      {/* Divider */}
      <div
        style={{
          height: 1,
          background: darkMode ? "#374151" : "#f1f5f9",
          margin: "20px 0",
        }}
      />

      {/* Browse by Department — lives inside the same section card */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: 14,
        }}
      >
        <h2
          style={{
            fontSize: 17,
            fontWeight: 700,
            color: darkMode ? "#f9fafb" : "#1a1a2e",
            margin: 0,
            letterSpacing: "-0.2px",
          }}
        >
          Browse by Department
        </h2>

        {activeDept && (
          <button
            onClick={() => onSelectDept("")}
            style={{
              height: 32,
              padding: "0 14px",
              fontSize: 12.5,
              fontWeight: 500,
              borderRadius: 10,
              border: darkMode ? "1px solid #374151" : "1px solid #e5e7eb",
              background: darkMode ? "#1f2937" : "#fff",
              color: darkMode ? "#f3f4f6" : "#374151",
              cursor: "pointer",
              fontFamily: "inherit",
              transition: "border-color 0.12s",
              display: "flex",
              alignItems: "center",
              gap: 6,
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.borderColor = "#d1d5db")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.borderColor = "#e5e7eb")
            }
          >
            Clear filter ✕
          </button>
        )}
      </div>

      {/* Department pills */}
      <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
        {departmentStats.map((dept) => {
          const color = dept.metadata?.bg || "#6366f1";
          const isActive = activeDept === dept.name;
          return (
            <button
              key={dept.id}
              onClick={() => onSelectDept(isActive ? "" : dept.name)}
              style={{
                height: 36,
                display: "flex",
                alignItems: "center",
                gap: 7,
                padding: "0 14px",
                borderRadius: 20,
                border: `1px solid ${
                  isActive ? color : darkMode ? "#374151" : "#e5e7eb"
                }`,
                background: darkMode
                  ? isActive
                    ? color + "25"
                    : "#1f2937"
                  : isActive
                    ? color + "18"
                    : "#fff",
                cursor: "pointer",
                transition: "all 0.15s",
                fontFamily: "inherit",
              }}
              onMouseEnter={(e) => {
                if (!isActive)
                  e.currentTarget.style.boxShadow =
                    "0 1px 4px rgba(0,0,0,0.08)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = "none";
              }}
            >
              <span
                style={{
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  background: color,
                  flexShrink: 0,
                }}
              />
              <span
                style={{
                  fontSize: 13.5,
                  fontWeight: 600,
                  color: darkMode
                    ? "#f9fafb"
                    : isActive
                      ? "#111827"
                      : "#374151",
                  letterSpacing: "-0.01em",
                }}
              >
                {dept.name}
              </span>
              <span
                style={{
                  minWidth: 20,
                  height: 20,
                  borderRadius: "50%",
                  background: isActive
                    ? color + "28"
                    : darkMode
                      ? "#374151"
                      : "#f3f4f6",
                  color: isActive ? color : "#9ca3af",
                  fontSize: 11,
                  fontWeight: 600,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "0 4px",
                }}
              >
                {dept.memberCount}
              </span>
            </button>
          );
        })}
      </div>
    </>
  );
}
